import { SortingOption } from '~/modules/catalog/category/composables/useFacet/sortingOptions'

export const defaultSearchSortOption: SortingOption = {
  label: 'Relevant first',
  value: '',
  sortCode: 'relevance_DESC'
}
